var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148609",
    "data-name": "Rectangle 148609",
    width: 24,
    height: 24,
    transform: "translate(8996 -16265)",
    fill: "#0c0c0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "everyone",
    transform: "translate(-8996 16265)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_20745365411579179443",
    "data-name": 20745365411579180000,
    transform: "translate(8998.75 -16262.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8906",
    "data-name": "Path 8906",
    d: "M148.446,82.492c-.229-.007-.443-.111-.644.166-.651.887-1.795.7-2.7,1.275a.971.971,0,0,1,.6-.8,4.728,4.728,0,0,1,2.148-.921A.519.519,0,0,1,148.446,82.492Z",
    transform: "translate(-139.238 -80.696)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11739",
    "data-name": "Group 11739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8907",
    "data-name": "Path 8907",
    d: "M70.058,60.488a9.25,9.25,0,1,0,8.924,9.346A9.245,9.245,0,0,0,70.058,60.488Zm2.605,6.623c.118.575-.083.776-.624.769-.436-.014-.9-.194-1.337.173-.1.083-.748-.215-.776-.4-.1-.589-.457-.395-.776-.381-.367.021-.734.069-1.122.1.63-.527,1-1.614,2.106-.873.34-.1.54.152.776.312C71.583,66.523,72.005,67.458,72.663,67.112Zm-.644,10.448a7.926,7.926,0,0,1-8.369-2.349c-.561-.582-.18-1.254-.062-1.76.139-.61.055-1.025-.367-1.3-.97-.63-1-1.725-1.351-2.633-.575-1.5.215-2.792.908-4.053a1.378,1.378,0,0,1,1.129-.776c.222-.014.312-.076.374-.263.028-.09.118-.249.139-.243,1.088.291.908-.852,1.462-1.212-.339-.139-.492.166-.811.187a1.519,1.519,0,0,1,1.233-.7c.464.028.658-.409,1.046-.52.6-.18,1.178-.43,1.746.055.049.118-.007.229-.1.236a4.052,4.052,0,0,0-2.016.956,3.4,3.4,0,0,0,1.933-.824c.229-.2.5-.346.79-.083a2.134,2.134,0,0,0,1.3-.236c.506-.242.838.118,1.06.533.2.388-.062.658-.36.8-.27.132-.568-.055-.852-.125-.575-.139-1.427.727-1.282,1.3a.374.374,0,0,1,0,.457c-.2.09-.4.187-.6.284-.028-.014-.055-.035-.083-.048-.173-.1-.125-.395-.374-.423-.187.27.173.527,0,.79.1.423.2.8-.506.637-.478-.111-.464.436-.409.61.222.741-.312,1.046-.734,1.372a2.8,2.8,0,0,0-.845,2.369,1.62,1.62,0,0,0,2.2,1.226,1.581,1.581,0,0,1,1.164.118c.125.076.36.166.312.277-.277.658.3,1.046.443,1.566.049.194.139.457.049.582-.4.6.055,1.095.208,1.594.083.277.242.838.561.769a2.717,2.717,0,0,0,1.69-.693c.409-.492.36-1.3,1.1-1.552.194-1.49,1.365-2.626,1.559-4.136-.409-.021-.651.353-1.039.166a9.579,9.579,0,0,0,1-.97c.277-.353.644-.748.187-1.24-.506.076-.977.076-1.178-.637a1.927,1.927,0,0,0,1.469.353c.63-.353.866.215,1.129.547a6.752,6.752,0,0,1,.61,1.3c.173-.921-.229-1.642.042-2.543a7.123,7.123,0,0,1,.284,3.748A7.837,7.837,0,0,1,72.019,77.559Z",
    transform: "translate(-60.49 -60.487)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8908",
    "data-name": "Path 8908",
    d: "M254.819,253.758c-.041.132-.069.263.049.34s.236-.035.3-.132a6.368,6.368,0,0,0,.714-1.566A2.986,2.986,0,0,0,254.819,253.758Z",
    transform: "translate(-241.323 -239.104)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8909",
    "data-name": "Path 8909",
    d: "M279.755,169.2l-.055.055A.107.107,0,0,0,279.755,169.2Z",
    transform: "translate(-264.512 -161.668)",
    fill: "#0c0c0b"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.0a977840.svg";
export { ForwardRef as ReactComponent };